import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'public-video-popup',
  templateUrl: 'public-video-popup.component.html',
})
export class PublicVideoPopupComponent implements OnInit {
  initialized = false;

  @Input()
  videoLink: string;

  @Input()
  analysisName: string;

  @Input()
  encoded: boolean;

  @Input()
  description: string;


  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void
  {
    this.analysisName = this.trimAnalysisName(this.analysisName)
    this.initialized = true;
  }

  trimAnalysisName(analysisName: string): string
  {
    if (!analysisName) return '';
    if (analysisName.length <= 50) return analysisName;

    const start = analysisName.slice(0, 25);
    const end = analysisName.slice(-25);
    return `${start}...${end}`;
  }

}
